import { render, staticRenderFns } from "./role-select.vue?vue&type=template&id=30f20aca&scoped=true"
import script from "./role-select.vue?vue&type=script&lang=js"
export * from "./role-select.vue?vue&type=script&lang=js"
import style0 from "./role-select.vue?vue&type=style&index=0&id=30f20aca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f20aca",
  null
  
)

export default component.exports